import React from 'react';

import { DateTime } from 'luxon';
import { capitalize } from 'lodash';

import { client } from '@admin/libraries/apollo';
import { usePredecessorOrderSelectorQuery, Order } from '@admin/schema';

const FROM_ISO_OPTIONS = { setZone: true };

const OrderOption: React.FC<{
  order: Pick<Order, 'id' | 'scheduled' | 'type' | 'subtype' | 'number'>;
}> = ({ order }) => {
  const { id, number } = order;
  const scheduled = DateTime.fromISO(order.scheduled, FROM_ISO_OPTIONS);
  const type = order.type.toLowerCase();
  const subtype = order.subtype.toLowerCase();

  return (
    <option value={id}>
      {scheduled.toLocaleString(DateTime.DATETIME_FULL)} - {type} - {subtype} - {number}
    </option>
  );
};

export const PredecessorOrderSelector: React.FC<{
  accountID: number | string;
  orderType: string;
  orderID?: number | string;
  predecessorID: number | string;
  onSelectPredecessorID(predecessorID?: number | string): void;
}> = ({ accountID, orderType, orderID, predecessorID, onSelectPredecessorID }) => {
  const { data } = usePredecessorOrderSelectorQuery({
    client,
    variables: {
      accountID: String(accountID),
      orderType: capitalize(orderType),
      orderID: orderID ? String(orderID) : undefined,
    },
  });

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();
    event.stopPropagation();

    onSelectPredecessorID(event.target.value ? event.target.value : undefined);
  };

  const isMove = orderType === 'moving-move'; // Moves should use the `Manage Follow-Ups` button

  return (
    <select className="form-control" onChange={onChange} value={predecessorID ?? ''} disabled={isMove}>
      <option value=""> -- None -- </option>
      {data?.potentialPredecessorOrders?.map((order) => (
        <OrderOption key={order.id} order={order} />
      ))}
    </select>
  );
};
